import BaseModel from "../../../../core/components/input-widget/BaseModel";
import i18n from "../../../../shared/i18n";

export default class CityModel extends BaseModel {
  name = '';
  state_uuid = '';
  county_uuid = '';
  tax_rate = null;
  exclude_tax_for_premium = false;

  rules = {
    name: 'required',
    state_uuid: 'required',
    county_uuid: 'required',
  };

  attributeLabels = {
    name: i18n.t('Name'),
    state_uuid: i18n.t('State'),
    county_uuid: i18n.t('County'),
    tax_rate: i18n.t('Tax Rate'),
    exclude_tax_for_premium: i18n.t('Exclude Tax For Premium'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}